export default "__VITE_ASSET__CelPfW28__"